<template>
    <div>
        <div :class="`${menu.type}-menu`">
            <section>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="d-flex justify-content-between mt-4 mb-3">
                            <div class="align-self-center">
                                <h2 class="headline">
                                    <router-link :to="`/${siteSlug}/${menu.type}`" class="headline">
                                        {{ menu.type | ucFirst }} {{ $t("menu") }}
                                    </router-link>
                                </h2>
                            </div>
                            <div class="align-self-center">
                                <router-link :to="`/${siteSlug}/${menu.type}`" class="btn btn-view">
                                    <svg height="34" viewBox="0 0 24 24" width="34" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0h24v24H0z" fill="none" />
                                        <path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4z" />
                                    </svg>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <router-link :key="section.id" :to="`/${siteSlug}/${menu.type}?section_id=${section.id}`"
                        class="col-md-4 col-6 mb-4" v-for="section in menu.sections">
                        <div class="card card-simple">
                            <div class="image-wrapper image-loading bg-light">
                                <img :data-src="`/images/menu-category/${section.menu_category.id}?width=350&height=280&fit=crop`"
                                    alt="Section image" style="min-height: 150px" class="lazyload card-img-top">
                            </div>
                            <div class="card-body text-center">
                                <h5 class="card-title">
                                    <router-link :to="`/${siteSlug}/${menu.type}?section_id=${section.id}`">
                                        {{ section.menu_category.name }}
                                    </router-link>
                                </h5>
                            </div>
                        </div>
                    </router-link>
                </div>
            </section>
        </div>

        <slot></slot>
    </div>
</template>

<script>
export default {
    props: ['siteSlug', 'menu']
}
</script>
